import React, {useEffect, useRef} from 'react';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';
import {TotalsMove} from "../../model/TotalsMove";
import {getDeterministicColor} from "../../utils/getDeterministicColor";

interface LineChartProps {

    data: TotalsMove[];
}

const LineChartTotals: React.FC<LineChartProps> = ({ data }) => {
    const chartRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const ctx = chartRef.current?.getContext('2d');

        if (ctx) {
            const playerData: { [player: string]: { x: Date; y: number }[] } = {};

            data.forEach((move) => {
                const player = move.playerName;
                const moveDate = move.date;
                const deltaGulps = move.deltaGulps;

                if (!playerData[player]) {
                    playerData[player] = [];
                }

                const previousTotal = playerData[player].length > 0 ? playerData[player][playerData[player].length - 1].y : 0;
                const currentTotal = previousTotal + deltaGulps;

                playerData[player].push({ x: moveDate, y: currentTotal });
            });



            const datasets = Object.keys(playerData).map((player) => {
                const color = getDeterministicColor(player);

                return {
                label: player,
                data: playerData[player],
                backgroundColor: color,
                borderColor: color,
                borderDash: [],
                borderWidth: 2,
                pointRadius: 1,
                pointHoverRadius: 4,
                tension: 0.2,
                };
            });

            const chart = new Chart(ctx, {
                type: 'line',
                data: {
                    datasets,
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: false,
                    plugins: {
                        legend: {
                            labels: {
                                color: '#d4d9e2',
                                boxWidth: 10,
                                boxHeight: 10,
                                font: {
                                    size: 11,
                                },
                            }
                        },
                        tooltip: {
                            backgroundColor: '#141821',
                            titleColor: '#f5f7fb',
                            bodyColor: '#e3e8f0',
                            borderColor: 'rgba(255,255,255,0.16)',
                            borderWidth: 1,
                        },
                    },
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: 'day',
                                parser: 'YYYY-MM-DD',
                                tooltipFormat: 'll'
                            },
                            ticks: {
                                color: '#9aa4b2',
                            },
                            grid: {
                                color: 'rgba(255,255,255,0.08)',
                            },
                        },
                        y: {
                            beginAtZero: true,
                            ticks: {
                                color: '#9aa4b2',
                            },
                            grid: {
                                color: 'rgba(255,255,255,0.08)',
                            },
                        },
                    },
                },
            });

            return () => {
                chart.destroy();
            };
        }
    }, [data]);

    return <canvas ref={chartRef} />;
};

export default LineChartTotals;
